import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Menu as MenuMui,
  MenuItem,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Scanner as ScannerIcon,
  HourglassEmpty as PendingIcon,
  AccountCircle,
} from "@mui/icons-material";
import authService from "../services/authService";

const LandingPage = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const user = authService.getCurrentUser();

  // State for user dropdown menu in top right
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    authService.logout();
    navigate("/login");
    window.location.reload();
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // Sidebar Content
  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
          bgcolor: "#1a1a1a",
          color: "white",
        }}
      >
        <Typography variant="h6">Rataul Tools</Typography>
      </Box>
      <List>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <ScannerIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Project Scan" />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton disabled>
            <ListItemIcon>
              <PendingIcon />
            </ListItemIcon>
            <ListItemText primary="Coming Soon..." secondary="More projects" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Top App Bar */}
      <AppBar position="static" sx={{ backgroundColor: "#1a1a1a" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Dashboard
          </Typography>

          {/* User Info & Logout (Top Right) */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="body1"
              sx={{ mr: 2, display: { xs: "none", sm: "block" } }}
            >
              {user?.email || "User"}
            </Typography>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <MenuMui
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>Profile</MenuItem>
              <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
                Logout
              </MenuItem>
            </MenuMui>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Left Sidebar Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        transitionDuration={400}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopRightRadius: "10px",
            borderBottomRightRadius: "10px",
            overflow: "hidden",
          },
        }}
      >
        {list()}
      </Drawer>

      {/* Main Content Area */}
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="h3" gutterBottom>
          Welcome Home Buddy!
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Select a project from the menu to get started.
        </Typography>
      </Box>
    </Box>
  );
};

export default LandingPage;
